import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'flat-gauge',
    templateUrl: 'flat-gauge.html',
    styleUrls: ['./flat-gauge.scss'],
    imports: [NgStyle]
})
export class FlatGaugeComponent {
    @Input()
    trackHeight: string = '15px';

    @Input()
    trackMin: number = 0;

    @Input()
    trackMax: number = 100;

    @Input()
    trackColorHexa: string = '#6F6F6F';

    @Input()
    markers: Marker[] = [];

    getPositionPercentage(marker: Marker): number {
        let position = this.trackMin;
        if (this.trackMin === this.trackMax) return position;
        position = Math.round(((marker.value - this.trackMin) / (this.trackMax - this.trackMin)) * 100);
        position = Math.max(position, 0);
        position = Math.min(position, 100);
        return position;
    }
}

export interface Marker {
    value: number;
    markerType?: string;
    label?: string;
    labelVerticalOffset?: number;
}
